"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var credit_card_icon_1 = require("./legacy/credit_card_icon");
var reverify_card_container_1 = require("./reverify_card_container");
var SelectableCreditCard = /** @class */ (function (_super) {
    tslib_1.__extends(SelectableCreditCard, _super);
    function SelectableCreditCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectableCreditCard.prototype.renderCardSummary = function () {
        var cardAbout = this.props.creditCard.cardType + " ...." + this.props.creditCard.last4;
        var expiryDate = this.props.creditCard.expirationMonth + "/" + this.props.creditCard.expirationYear;
        return (React.createElement("div", { className: "cc-details__card-info" },
            React.createElement("div", { className: "cc-details__card-type" }, cardAbout),
            React.createElement("div", { className: "cc-details__expiration" }, I18n.t('discovery.selectableCreditCardList.expiresOn', { date: expiryDate }))));
    };
    SelectableCreditCard.prototype.cardId = function () {
        return this.props.creditCard.id;
    };
    SelectableCreditCard.prototype.reverifyCardField = function () {
        if (!this.props.creditCard.isSelected || !this.props.creditCard.needsReverification) {
            return null;
        }
        return (React.createElement(reverify_card_container_1.default, { creditCardId: this.cardId() }));
    };
    SelectableCreditCard.prototype.renderEditLink = function () {
        if (this.props.editPath) {
            return (React.createElement("a", { href: this.props.editPath, className: "boxed-list__action" }, I18n.t('discovery.selectableCreditCardList.edit')));
        }
    };
    SelectableCreditCard.prototype.render = function () {
        return (React.createElement("li", { className: "shop-onboarding__card", key: this.cardId(), onClick: this.props.onClick, id: "credit_card_" + this.cardId() },
            React.createElement("input", { className: "boxed-list__toggle", type: "radio", checked: this.props.creditCard.isSelected, id: "credit_card_" + this.props.creditCard.id, name: "payment[credit_card_id]", value: this.cardId(), readOnly: true }),
            React.createElement("label", { className: "boxed-list__item boxed-list__item--selectable", htmlFor: "credit_card_" + this.props.creditCard.id },
                React.createElement("div", { className: "cc-details" },
                    React.createElement("div", { className: "cc-details__card" },
                        React.createElement("div", { className: "cc-details__icon" },
                            React.createElement(credit_card_icon_1.default, { cardType: this.props.creditCard.cardType })),
                        this.renderCardSummary())),
                this.renderEditLink(),
                this.reverifyCardField())));
    };
    return SelectableCreditCard;
}(React.Component));
exports.default = SelectableCreditCard;
//# sourceMappingURL=selectable_credit_card.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/selectable_credit_card.js
// module id = zSVn
// module chunks = 20 21 22